<template>
  <div id="wrapper">
    <div id="content-wrapper" class="d-flex flex-column mt-2">
      <div id="content">
        <div class="container-fluid">
          <div class="card-columns row justify-content-md-center">
            <div :key="listMessageKey" class="col-sm-12 row card-columns justify-content-md-center">
              <div
                v-for="(message, index) in messages"
                v-bind:key="message.isOpen"
                :id="message.index"
                class="col-sm-10"
              >
                <div>
                  <div class="h-100 card shadow border-bottom-orange">
                    <div class="card-body">
                      <div class="row no-gutters">
                        <a class="col mr-2 w-100">
                          <div class="d-flex w-100 justify-content-between">
                            <h4 class="mb-1">{{ message.titulo }}</h4>
                            <div class="text-right">
                              <small v-if="message.destino.titulo !== 'SEM PAPEL'">{{ message.destino.titulo }}</small>
                              <div>
                                <span v-if="!message.isOpen" class="link" @click.prevent="toogleMessage(index)">
                                  <i class="fa fa-envelope" aria-hidden="true"></i>
                                  ABRIR MENSAGEM
                                </span>
                                <span v-if="message.isOpen" class="link" @click.prevent="toogleMessage(index)">
                                  <i class="fa fa-envelope-open" aria-hidden="true"></i>
                                  FECHAR MENSAGEM
                                </span>
                              </div>
                            </div>
                          </div>
                          <p v-if="message.isOpen" class="mb-0">{{ message.texto }}</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="menu in menus"
              :key="menu.title + menu.number"
              :class="`${isMenu ? isSelected(menu.title) ? 'col-xl-5 col-sm-8' : 'col-xl-1 col-sm-2' : menu.column} mb-4`"
              :id="menu.id"
            >
              <div v-if="isElementMenuVisible(menu.onlyMenu)">
                <div :class="`${isMenu ? '' : 'h-100 py-2'} card shadow ${menu.borderCard}`">
                  <div class="card-body">
                    <div class="row no-gutters">
                      <a :class="`${menu.disable ? 'disable' : ''} link col mr-2 text-center w-100`" routerLink="#" @click="navegar(menu.rota, menu.title)">
                        <titleComp
                          :icon="menu.icon"
                          :title="menu.title"
                          :color="menu.disable ? '#DCDCDC' : menu.color"
                          :isMenu="isMenu"
                          :selected="isSelected(menu.title)"
                          :svg="menu.svg"
                        />
                      </a>
                      <numberComp
                        :number="menu.number"
                        :subtitle="menu.subtitle"
                        :hasNumber="menu.hasNumber"
                        :isMenu="isMenu || menu.disable"
                        :color="menu.subtitleColor || menu.color"
                        :selected="isSelected(menu.title)"
                        :informations="menu.informations"
                      >
                        <div :key="link.id" v-for="link in menu.links">
                          <span @click="navegar(link.rota, menu.title)" class="badge badge-secondary text-md link">
                            {{ link.text }}
                          </span>
                          <br>
                        </div>
                      </numberComp>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <slot></slot>
      </div>
    </div>
    <modal ref="caixaMensagem" width="500px" height="">
        <template v-slot:header>
          <div class="modal-header">
            <h4 class="text-primary m-3">ATENÇÃO</h4>
            <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.caixaMensagem.closeModal()" />
          </div>
        </template>
        <template v-slot:body>
          <div class="modal-body text-md-center text-sm-center">
            <div>
              Você tem mensagens não lidas
            </div>
            <button type="button" class="btn btn-outline-primary mt-2" @click="$refs.caixaMensagem.closeModal()">Confirmar</button>
          </div>
      </template>
    </modal>
  </div>
</template>

<script>
import '@/assets/scss/custom.css'
import numberComp from '@/components/home/number.vue'
import titleComp from '@/components/home/title.vue'
import modal from '@/components/shared/Modal.vue'
import { componentIsVisible, rules } from '@/uteis/action/permissao'

import WorkAreaService from '@/services/WorkAreaService'
import VirtusMensagemService from '@/services/VirtusMensagemService'

export default {
  name: '',

  components: {
    numberComp,
    titleComp,
    modal
  },

  data () {
    return {
      nome: '',
      isMenu: false,
      selected: '',
      countAReceber: null,
      countElaboracao: null,
      protocolosLinks: [],
      mensagensPendente: null,
      messages: [],
      listMessageKey: false
    }
  },

  computed: {
    menus () {
      return [{
        title: 'A RECEBER',
        icon: 'fa fa-check-square-o',
        styleTitulo: 'color: rgb(0, 204, 0);',
        color: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/receber',
        number: this.countAReceber,
        subtitle: 'Protocolos a receber',
        hasNumber: true,
        column: 'col-md-4 col-sm-12',
        svg: 'receber',
        id: 'receber',
        disable: false
      },
      {
        title: 'ELABORAÇÃO',
        icon: 'fa fa-pencil',
        styleTitulo: 'color: rgb(153, 0, 255);',
        color: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/elaboracao/consulta',
        number: this.countElaboracao,
        subtitle: 'Protocolos',
        hasNumber: true,
        informations: [
          'Últimos Protocolos:'
        ],
        links: this.protocolosLinks,
        column: 'col-md-4 col-sm-12',
        svg: 'elaboracao',
        id: 'elaboracao',
        disable: false
      },
      {
        title: 'NO SETOR',
        icon: 'fa fa-folder-open-o',
        styleTitulo: 'color: rgb(255, 0, 0);',
        color: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/setor',
        number: 15,
        subtitle: 'Protocolos no setor',
        hasNumber: false,
        column: 'col-md-3 col-sm-6',
        svg: 'setor',
        id: 'setor',
        disable: false
      },
      {
        title: 'MEUS',
        icon: 'fa fa-user-o',
        styleTitulo: 'color: rgb(23, 162, 184, 1);',
        color: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/meus',
        number: 15,
        subtitle: 'Meus protocolos',
        hasNumber: false,
        column: 'col-xl-3 col-md-4 col-sm-6',
        svg: 'meus',
        id: 'meus',
        disable: false
      },
      /* {
        title: 'RESERVADOS',
        icon: 'fa fa-files-o',
        styleTitulo: 'color: rgb(255, 153, 0);',
        color: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/reservados',
        number: 15,
        subtitle: 'Reservas',
        hasNumber: false,
        column: 'col-xl-2 col-md-3 col-sm-6',
        svg: 'reservados'
      }, */
      {
        title: 'TRAMITADOS',
        icon: 'fa fa-share',
        styleTitulo: 'color: rgb(43, 120, 228);',
        color: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/tramitados',
        subtitle: 'Protocolos a tramitados',
        number: 15,
        hasNumber: false,
        column: 'col-xl-3 col-md-4 col-sm-6',
        svg: 'tramitados',
        id: 'tramitados',
        disable: false
      },
      {
        title: 'BUSCA GERAL',
        icon: 'fa fa-share',
        styleTitulo: 'color: rgb(43, 120, 228);',
        color: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/buscaGeral',
        subtitle: 'Protocolos a tramitados',
        number: 15,
        hasNumber: false,
        column: 'col-xl-2 col-md-4 col-sm-6',
        svg: 'busca-geral',
        id: 'busca-geral',
        disable: false
      },
      {
        title: 'SPI',
        icon: 'fa fa-share',
        styleTitulo: 'color: rgb(43, 120, 228);',
        color: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/legado',
        subtitle: 'Protocolos a tramitados',
        number: 15,
        hasNumber: false,
        column: 'col-xl-3 col-md-4 col-sm-6',
        svg: 'spi',
        id: 'spi',
        disable: false
      },
      {
        title: 'Interessados',
        icon: 'fa fa-share',
        styleTitulo: 'color: rgb(43, 120, 228);',
        color: '#4a75b5',
        borderCard: 'border-bottom-primary',
        rota: '/interessados',
        subtitle: 'Protocolos a tramitados',
        number: 15,
        hasNumber: false,
        column: 'col-xl-3 col-md-4 col-sm-6',
        svg: 'contato-externo',
        id: 'contato-externo',
        disable: false
      },
      {
        title: 'Menu Gerencial',
        icon: 'fa fa-commenting-o',
        styleTitulo: 'color: rgb(43, 120, 228);',
        color: '#e4bb3d',
        subtitleColor: '#e4bb3d',
        borderCard: 'border-bottom-orange',
        rota: '/workArea/admin',
        subtitle: 'Mensagens Pendentes',
        number: this.mensagensPendente || 0,
        hasNumber: false,
        column: 'col-md-4 col-sm-6',
        svg: 'admin',
        id: 'admin',
        disable: !this.menuGerencialIsVisible()
      },
      {
        title: 'MANTER ELABORAÇÃO',
        icon: 'fa fa-plus-square-o',
        styleTitulo: 'color: rgb(43, 120, 228);',
        color: '#81c784',
        borderCard: 'border-bottom-primary',
        rota: '/elaboracao/manter',
        subtitle: '',
        number: 15,
        hasNumber: false,
        column: 'col-md-12',
        onlyMenu: true,
        disable: true
      },
      {
        title: 'HOME',
        icon: 'fa fa-home',
        styleTitulo: 'color: rgb(43, 120, 228);',
        color: '#757575',
        borderCard: 'border-bottom-primary',
        rota: '/workArea',
        subtitle: '',
        number: 15,
        hasNumber: false,
        column: 'col-md-12',
        onlyMenu: true,
        disable: true
      }]
    }
  },

  methods: {
    navegar (url, title) {
      this.isMenu = true
      this.selected = title

      try {
        this.$router.push({ path: url })
      } catch (error) {
        console.log(error)
      }
    },

    toogleMessage (index) {
      this.messages[index].isOpen = this.messages[index].isOpen === undefined ? true : !this.messages[index].isOpen
      this.listMessageKey = !this.listMessageKey
    },

    isSelected (title) {
      return this.selected === title
    },

    isElementMenuVisible (onlyMenu) {
      return !onlyMenu ? true : onlyMenu === this.isMenu
    },

    caixaDeMensagemIsVisible () {
      const { CRIAR_ALERTA } = rules
      return componentIsVisible(CRIAR_ALERTA)
    },

    menuGerencialIsVisible () {
      const { ACESSAR_GERENCIAL } = rules
      return componentIsVisible(ACESSAR_GERENCIAL)
    },

    protocolosAReceber () {
      const dadosSessao = this.$store.getters.getDadosSessao
      var filtro = {
        tipoIdentificador: 'ID',
        identificador: dadosSessao.sessao.idDepartamento,
        option: 'no-data',
        armazenado: false,
        arquivado: false,
        anexado: false,
        eliminado: false,
        apensado: false,
        emTramite: true,
        offset: 1,
        range: 10
      }

      this.virtusService.consultarProcessosAReceber(filtro).then(res => {
        this.countAReceber = res.pagination.totalReg
      }).catch(err => {
        console.log(err)
      })
    },

    protolocos () {
      const dadosSessao = this.$store.getters.getDadosSessao

      var filtro = {
        idDepartamento: dadosSessao.sessao.idDepartamento,
        option: 'no-data',
        offset: 1,
        range: 10,
        apensado: false
      }

      this.virtusService.consultarProcessosElaboracao(filtro).then(res => {
        this.countElaboracao = res.pagination.totalReg
      }).catch(err => {
        console.log(err)
      })

      var filtroProtocolos = { ...filtro }
      filtroProtocolos.range = 3
      delete filtroProtocolos.option

      this.virtusService.consultarProcessosElaboracao(filtroProtocolos).then(res => {
        var links = []
        for (var protocolo of res.data) {
          var link = {
            text: `${protocolo.numeroProcesso}, ${protocolo.atributos.dataCriacaoFormatada}`,
            rota: `/virtus/visualizadorProcesso?numeroProcesso=${protocolo.numeroProcesso}`,
            id: protocolo.numeroProcesso
          }
          links.push(link)
        }
        this.protocolosLinks = links
      }).catch(err => {
        console.log(err)
      })
    },

    getMensagensPendentes () {
      const now = new Date().toISOString()
      this.mensagemService.getMensagens({
        date: now.split('T')[0],
        'destino.tipoIdentificador': 'PAPEL'
      }).then(res => {
        this.messages = res.data
      }).catch(err => {
        console.log(err)
      })
    }
  },

  created () {
    this.dadosSessao = this.$store.getters.getDadosSessao.sessao
    this.nome = this.dadosSessao.nomeUsuario

    this.virtusService = new WorkAreaService()
    this.mensagemService = new VirtusMensagemService()

    this.protocolosAReceber()
    this.protolocos()
    this.getMensagensPendentes()
  }
}
</script>

<style scoped lang='scss'>
</style>
